import axiosApiInstance from '../../interceptors/axiosApiInstance';
import { BASE_URL, AUTOMMATE_API_URL } from '../config';
// import { setServiceMessage } from '../../helpers/helper';

const IpaasService = {
    getIpaas: async function (params, et) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/ipaas?environment_target=${et}${params ? `&filter=${JSON.stringify(params)}` : ''}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    checkItExist: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/ipaas/check/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getIpaasDetails: async function (id) {
        try {
            const response = await axiosApiInstance.get(AUTOMMATE_API_URL + `/ipaas/${id}/detail`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    downloadIpaas: async function (id, environment_target) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/ipaas/download', { bot_id: id, environment_target });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getIpaasBots: async function () {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + "/ipaas/products");
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    startIpaas: async function (id) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/ipaas/start`,
                {
                    id
                }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    changeStatus: async function (data, id) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/ipaas/status/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    stopIpaas: async function (id) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/ipaas/stop`,
                {
                    id
                }
            );
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Active Ipaas Count
     * @Param       startDate="", endDate=""
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getIpaasCount: async function (startDate = "", endDate = "") {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/ipaas/count?startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getApprovements: async function (status) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/ipaas/approvements?status=${status}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    putApprovement: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(await BASE_URL + `/ipaas/publish-approve/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deletePublishRequest: async function (id) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + `/ipaas/approvement/delete`, { id });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
}
export default IpaasService;